import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { urls } from 'constants/urls.constant';

import { AuthService } from 'use-cases/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SignInGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(): boolean {
    if (this.authService.isAuthenticated) {
      void this.router.navigate([urls.home]);
    }

    return !this.authService.isAuthenticated;
  }
}
